import type { User } from "@/api/generated/api";

// MoneyAmount.未選択 の値。ここで型（enum）を実行時 import すると api.ts 経由で axios(ESM) を
// 取り込み jest が解釈できなくなるため、文字列定数として持つ。モーダル側の判定とも共有する。
export const FINANCIAL_ASSET_UNSELECTED = "未選択";

/**
 * 起動時プロフィール入力モーダルで、ユーザーが未入力のフィールド。
 */
export type MissingStartupProfileFields = {
  /** interested_property_type_ids が未設定または空配列 */
  interest: boolean;
  /** has_investment_experience が null / undefined（false は回答済み扱い） */
  experience: boolean;
  /** financial_asset が未設定 / 空 / "未選択" */
  financialAsset: boolean;
};

/**
 * ユーザーの未入力フィールドを判定する純関数。
 * GET /v1/user（UserSerializer）は interested_property_type_ids を
 * user_interested_property_types から生成するため、この配列のみを判定材料にする。
 */
export const getMissingStartupProfileFields = (user: User | null | undefined): MissingStartupProfileFields => {
  if (!user) {
    return { interest: false, experience: false, financialAsset: false };
  }

  const ids = user.interested_property_type_ids;
  const interest = !ids || ids.length === 0;

  // false は「経験なし」という有効回答なので、null / undefined のみ未入力とみなす。
  const experience = user.has_investment_experience === null || user.has_investment_experience === undefined;

  const financialAsset = !user.financial_asset || (user.financial_asset as string) === FINANCIAL_ASSET_UNSELECTED;

  return { interest, experience, financialAsset };
};

/**
 * 起動時プロフィール入力モーダルを表示すべきか（未入力フィールドが1つ以上あるか）。
 */
export const shouldShowStartupProfileModal = (user: User | null | undefined): boolean => {
  const missing = getMissingStartupProfileFields(user);
  return missing.interest || missing.experience || missing.financialAsset;
};
